module.exports = __webpack_public_path__ + "static/wejscie_thumb-b6897c9f1dfc3e83fca007b7fdb71eed.jpg";